import { Link } from 'react-router-dom';

interface MovieCardProps {
  id: string;
  title: string;
  category: string;
  rating: number;
  imageUrl: string;
  tags?: string[];
  episode?: string;
}

const categoryLabels: Record<string, string> = {
  movie: '电影',
  tv: '电视剧',
  variety: '综艺',
  anime: '动漫',
};

export default function MovieCard({ id, title, category, rating, imageUrl, tags, episode }: MovieCardProps) {
  return (
    <Link
      to={`/article/${id}`}
      className="group block cursor-pointer"
    >
      <div className="relative overflow-hidden rounded-lg aspect-[3/4] bg-background-200">
        <img
          src={imageUrl}
          alt={title}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          title={`${title} - 在线观看`}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />

        <div className="absolute top-2 left-2">
          <span className="inline-block px-2 py-0.5 rounded text-xs font-medium bg-primary-500 text-background-50">
            {categoryLabels[category] || category}
          </span>
        </div>

        <div className="absolute top-2 right-2">
          <span className="inline-flex items-center gap-0.5 px-1.5 py-0.5 rounded text-xs font-bold bg-background-950/70 text-accent-400">
            {rating}
          </span>
        </div>

        {episode && (
          <div className="absolute bottom-2 right-2">
            <span className="inline-block px-2 py-0.5 rounded text-xs font-medium bg-background-950/70 text-background-100">
              {episode}
            </span>
          </div>
        )}
      </div>

      <div className="mt-3">
        <h3 className="text-sm md:text-base font-semibold text-foreground-900 line-clamp-1 group-hover:text-primary-500 transition-colors">
          {title}
        </h3>
        {tags && tags.length > 0 && (
          <div className="flex flex-wrap gap-1.5 mt-1.5">
            {tags.map((tag) => (
              <span
                key={tag}
                className="inline-block px-2 py-0.5 rounded text-xs text-foreground-500 bg-background-100 border border-background-200/70"
              >
                {tag}
              </span>
            ))}
          </div>
        )}
      </div>
    </Link>
  );
}